<template>
  <el-dialog 
    :width="pda.status ? '90%': '1000px'" 
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="beforeClose"
    :fullscreen="fullscreen"
    :append-to-body="true"
    >
    <div slot="title" class="dialog-title">
      <i class="el-icon-suitcase"></i>
      <!-- {{item.is_short_term > 0 ? '外来' : ''}}器械包明细 -->
      <span class="title-text">{{item.is_short_term > 0 ? `外来器械` : `器械包`}}明细</span>
    </div>
    <!-- 退出全屏 全屏 -->
    <el-button type="primary" class="fullscreen-btn" @click="toggleFullScreen">{{fullscreen ? `退出全屏` : `全屏`}}</el-button>
    <div class="info-line">
      <!-- 器械包名称 -->
      <label class="ml10">器械包名称</label><el-tag class="ml10">{{ item.name }}</el-tag>
      <span v-if="item.is_short_term > 0">
        <!-- 厂家 -->
        <label class="ml10">厂家</label><el-tag class="ml10">{{ item.vendor_name }}</el-tag>
      </span>
      <span v-if="item.is_short_term > 0 && !exec[483] && !exec[487]">
        <!-- 拆卸前总数 -->
        <label class="ml10">拆卸前总数</label><el-tag class="ml10">{{ item.number_prev }}</el-tag>
      </span>
      <span v-if="item.is_short_term > 0 && exec[483] && exec[487]">
        <!-- 器械件数 -->
        <label class="ml10">器械件数</label><el-tag class="ml10">{{ item.number }}</el-tag>
      </span>
      <!-- 拆卸后总数 -->
      <span v-if="item.is_short_term > 0 && !exec[483] && !exec[487]">
        <label class="ml10">拆卸后总数</label><el-tag class="ml10">{{ item.number }}</el-tag>
      </span>
      <span v-if="item.is_short_term > 0 && exec[483] && exec[487]">
        <!-- 植入物数量 -->
        <label class="ml10">植入物数量</label><el-tag class="ml10">{{ item.has_plant}}</el-tag>
      </span>
      <!-- 物品总数 -->
      <span v-if="item.is_short_term > 0 && !exec[483] && !exec[487]">
        <label class="ml10">物品总数</label><el-tag class="ml10">{{ item.number }}</el-tag>
      </span>
      <!-- 是否有植入物 -->
      <span v-if="item.is_short_term > 0">
        <label class="ml10">植入物</label><el-tag class="ml10">{{ item.has_plant ? '有' : '无' }}</el-tag>
      </span>
      <!-- 包装方式 -->
      <span v-if="item.pack_option">
        <label class="ml10">包装方式</label><el-tag class="ml10">{{ packOption }}</el-tag>
      </span>
      <!-- 处理方式 -->
      <span v-if="item.sterilization_option">
        <label class="ml10">处理方式</label><el-tag class="ml10">{{ sterilizationOption || '#' }}</el-tag>
      </span>
      <!-- 回收备注 -->
      <span v-if="item.recycle_remark && (processIn === 'clean' || processIn === 'prepare' || processIn === 'pack')">
        <label class="ml10">回收备注</label><el-tag class="ml10">{{ item.recycle_remark || '#' }}</el-tag>
      </span>
      <!-- 特殊备注 -->
      <span v-if="item.inner_code_remark">
        <label class="ml10">特殊备注</label><el-tag class="ml10">{{ item.inner_code_remark || '#' }}</el-tag>
      </span>
      <!-- 病人姓名 -->
      <span v-if="item.patient_data">
        <label class="ml10">病人姓名</label><el-tag class="ml10">{{ item.patient_data.patient_name || '#' }}</el-tag>
      </span>
      <span v-if="item.patient_data">
        <label class="ml10">{{ patientCodeStr }}</label><el-tag class="ml10">{{ item.patient_data.patient_id || '#' }}</el-tag>
      </span>
      <!-- 器械总数 -->
      <span class="highlight" v-if="item.is_short_term === 0">
        <label class="ml10">器械总数</label><el-tag class="ml10">{{ item.number || '0' }}</el-tag>
      </span>
      <!-- 耗材总数 -->
      <span class="highlight" v-if="item.is_short_term === 0">
        <label class="ml10">耗材总数</label><el-tag class="ml10">{{ item.disposable_number || '0' }}</el-tag>
      </span>
    </div>
    <p v-if="item.description" class="mt10 mt10">
      <span>
        <!-- 配包注意事项 -->
        <label class="ml10">配包注意事项</label><el-tag class="ml10">{{ item.description || '#'}}</el-tag>
      </span>
    </p>
    <div class="mt10">
      <span v-if="processIn === 'recycle'">
        <!-- 回收注意事项 -->
        <label class="ml10">回收注意事项</label><el-tag class="ml10">{{ item.recycle_description || '#'}}</el-tag>
      </span>
      <span v-if="processIn === 'clean'">
        <!-- 清洗注意事项 -->
        <label class="ml10">清洗注意事项</label><el-tag class="ml10">{{ item.clean_description || '#'}}</el-tag>
      </span>
      <span v-if="processIn === 'sterilize'">
        <!-- 灭菌注意事项 -->
        <label class="ml10">灭菌注意事项</label><el-tag class="ml10">{{ item.sterilize_description || '#'}}</el-tag>
      </span>
      <span v-if="processIn === 'out'">
        <!-- 发放注意事项 -->
        <label class="ml10">发放注意事项</label><el-tag class="ml10">{{ item.out_description || '#'}}</el-tag>
      </span>
    </div>
    <div class="mt10 ml5 d-flex top" :class="{'vertical': pda.status}">
      <div class="left" :style="`${isShow ? 'width: 100%' : ''};${scaleConfig ? `flex: ${scaleConfig[0] || 1}` : ''};`">
        <el-carousel class="image-list">
          <el-carousel-item v-for="i in item.image && item.image.length > 0 ? item.image : [{}]" :key="i.id">
            <el-image class="cover" :src="i.url || defaultImg" :preview-src-list="(item.image ? item.image : []).map(s => s.url)" @click="imageClick"></el-image>
          </el-carousel-item>
        </el-carousel>
        <!-- 文件列表 -->
        <label class="title mt10" v-if="item.file && item.file.length > 0">文件</label>
        <p class="video-item" v-for="(v, vi) in item.file && item.file.length > 0 ? item.file : []" :key="vi" @click="openFile(v)">{{`${v.name}`}}</p>
      </div>
      <div class="right" :style="`${isShow ? 'width: 100%' : ''};${scaleConfig ? `flex: ${scaleConfig[1] || 2}` : ''};`">
        <div class="d-flex between mb10">
          <div>
            <el-tabs v-if="item.spd_data && item.spd_data.length" v-model="activeTab">
              <!-- 器械明细 -->
              <el-tab-pane :label="`器械明细`" name="instrument"></el-tab-pane>
              <!-- SPD绑定明细 -->
              <el-tab-pane :label="'SPD'+`绑定明细`" name="spd"></el-tab-pane>
            </el-tabs>
          </div>
          <table-header-editor :headers="tableHeaders" />
        </div>
        <el-table
          v-if="activeTab === 'instrument'"
          ref="instruments"
          style="width: 100%;"
          max-height="600px"
          border
          :data="item.instrument"
          :row-style="tableRowClassName"
          >
          <el-table-column
            type="index"
            label="#"
            align="center"
            :index="indexMethod"
            width="50">
          </el-table-column>
          <el-table-column
            v-for="(val) in tableHeaders"
            :key="val.id"
            :type="val.type"
            :label="val.label"
            :prop="val.prop"
            :sortable="!!val.sortKey ? 'custom': false"
            :sort-by="val.sortKey"
            :width="val.width || 'auto'">
              <template slot-scope="scope">
                <span v-if="val.prop === 'image'">
                  <span v-for="(i, index) in scope.row.image" :key="index" style="width: 40px;height: 40px;overflow: hidden;display:inline-block;">
                    <el-image class="cover" :src="i.url || defaultImg" :preview-src-list="(scope.row.image ? scope.row.image : []).map(s => s.url)" @click="imageClick"></el-image>
                  </span>
                </span>
                <span v-else-if="val.prop === 'number' && item.is_short_term > 0">
                  <span>{{processIn === 'outInstrumentSourch' && scope.row.last_number > -1 && scope.row.show_number === 1 ? scope.row.last_number + ' | ' : ''}}{{scope.row.show_number === 1 ? scope.row.number: ''}}</span>
                </span>
                <span v-else-if="val.prop === 'number_prev'">
                  <span class="">{{ processIn === 'outInstrumentSourch' && scope.row.last_number_prev > -1? scope.row.last_number_prev + ' | ' : '' }}{{scope.row.number_prev}}</span>
                </span>
                <span v-else-if="val.prop === 'handle'">
                  <!-- 器械问题登记 -->
                  <el-button v-if="showInstrumentQuestionRecord" type="primary" size="small" @click="recordQuestion(scope.row)">器械问题登记</el-button>
                  <!-- {{ processIn === 'recycle' ? '取消扫描': '删除udi'}} -->
                  <el-button v-if="(processIn == 'prepare' || processIn == 'prepareToPack' || (processIn === 'recycle' && scope.row.udi_scaned)) && scope.row.udi" type="primary" size="small" @click="handleDelUdi(scope.row)" class="ml5 mt5">{{ processIn === 'recycle' ? `取消扫描`: `删除`+'udi'}}</el-button>
                </span>
                <span :style="{'color': udiColor(scope.row)}" v-else-if="val.prop === 'udi'">
                  {{scope.row.udi}}
                </span>
                <span v-else>{{scope.row[val.prop]}}</span>
              </template>
          </el-table-column>
        </el-table>
        <el-table
          v-if="activeTab === 'spd'"
          style="width: 100%;"
          max-height="600px"
          border
          :data="item.spd_data"
          >
          <el-table-column
            type="index"
            label="#"
            align="center"
            width="50">
          </el-table-column>
          <el-table-column
            v-for="(item) in SPDheaders"
            :key="item.id"
            :type="item.type"
            :label="item.label"
            :prop="item.prop"
            :sortable="!!item.sortKey ? 'custom': false"
            :sort-by="item.sortKey"
            :width="item.width">
              <template slot-scope="scope">
                <span>{{scope.row[item.prop]}}</span>
              </template>
          </el-table-column>
        </el-table>
        <slot name="remark"></slot>
      </div>
    </div>
    <div class="mt10 d-flex right">
      <slot></slot>
    </div>
    <el-dialog :width="pda.status ? '90%' : '600px'" :visible.sync="video.show" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <!-- 视频预览 -->
        <span class="title-text">视频预览</span>
      </div>
      <video ref="videoPlayer" style="width:100%;height: 400px;" :src="video.url" controls></video>
    </el-dialog>

    <!-- 器械问题登记 -->
    <question-record ref="questionRecord" @done="questionRecordDone" />
    <clean-unstanard ref="cleanUnstanard" />

    <!-- udi未匹配列表 -->
    <udi-list ref="UdiList" />
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
const defaultImg = require('@/assets/img/default-avatar.png')
import { videoTypes } from '@/utils/Config.js'
import { deleteUdi, saveUdi } from '@/api.js'
import CleanUnstanard from '@/components/register/cleanUnstanard.vue'
import UdiList from './UdiList.vue'
export default {
  name: 'InstrumentDetail',
  components: {
    CleanUnstanard,
    UdiList
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      processIn: '',
      defaultImg,
      item: {
        image: [],
        file: []
      },
      packOptions: [],
      tableHeaders: [],
      sterilizationOptions: [],
      video: {
        show: false,
        url: ''
      },
      fullscreen: false,
      imgDefaultScale: 1,
      udiStatusConfig: [],
      udiNodes: [ // udi对应节点接口配置参数
        {
          type: 1,
          nodes: [
            'recycle'
          ]
        },
        {
          type: 2,
          nodes: [
            'prepare', 'prepareToPack'
          ]
        }
      ],
      SPDheaders:[
      {
        // 物品名
          label: `物品名称`,
          prop: 'name',
          width: 'auto',
        },
        {
          // 规格型号
          label: `规格型号`,
          prop: 'spec',
          width: 'auto',
        },
        {
          // 数量
          label: `数量`,
          prop: 'count',
          width: 'auto',
        },
      ],
      activeTab: 'instrument',
      tableColor: [],
      patientCodeStr: '',
      scaleConfig: null // 弹窗左右样式比例
    }
  },
  computed: {
    ...mapGetters(['exec', 'pda']),
    packOption() {
      const value = this.item.pack_option
      let name = ''
      this.packOptions.forEach(i => {
        if (i.value === value) {
          name = i.name
        }
      })

      return name
    },
    sterilizationOption() {
      const value = this.item.sterilization_option
      let name = ''
      this.sterilizationOptions.forEach(i => {
        if (i.value === value) {
          name = i.name
        }
      })

      return name
    },
    udiScanedColor() {
      // udi扫描成功标记颜色
      const config = this.udiStatusConfig.filter(i => i.value === 1)[0] || {}
      const color = config.name || ''

      return  color ? `${color} !important` : ''
    },
    udiIssueColor() {
      // udi问题登记颜色
      const config = this.udiStatusConfig.filter(i => i.value === 2)[0] || {}
      const color = config.name || ''
      
      return  color ? `${color} !important` : ''
    },
    showInstrumentQuestionRecord() {
      const { processIn, exec, item } = this
      if (processIn === 'recycle' && item.recycle_ids) {
        return exec[321] === 1
      } else if (processIn === 'prepare' || processIn === 'prepareToPack') {
        return exec[322] === 1
      }

      return false
    },
    instrumentTotal() {
      // 器械总数
      let total = 0
      this.item.instrument.forEach(i => {
        total += i.number
      })

      return total
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.item = {
          image: [],
          file: []
        }
      }
    },
    'video.show'(val) {
      if (!val) {
        this.$refs.videoPlayer.pause()
        this.video.url = null
      }
    }
  },
  created() {
    this.getDicts()
  },
  methods: {
    imageClick() {
      // 用于更改图片放大器展开时的默认大小
      const scale = this.imgDefaultScale
      this.$nextTick(() => {
        window.document.querySelector('.el-image-viewer__img').style.transform = `scale(${scale}) rotate(0deg)`
      })
    },
    getDicts() {
      return this.$utils.getDict([338, 5, 431, 463, 556, 407, 577]).then(res => {
        if (res) {
          this.packOptions = res[5]
          this.sterilizationOptions = res[338]
          const scale = res[431] ? res[431][0].name : null
          this.imgDefaultScale = scale ? Number(scale) : 1
          this.udiStatusConfig = res[463] || []
          this.tableColor = res[556]
          this.patientCodeStr = res[407] ? res[407][0]['name'] : ''
          this.scaleConfig = res[577] ? res[577][0]['name'].split(':') : null
        }
      })
    },
    open(item, processIn = '') {
      const { columns } = item
      let tableHeaders = this.$utils.generateColumns(columns || [])
      tableHeaders.forEach(i => {
        if (i.prop === 'number' || i.prop === 'number_prev') {
          i.disabled = true
        }
      })
      if (this.isShow) {
        const showHeaders = ['name', 'udi', 'number']
        tableHeaders = tableHeaders.filter(i => showHeaders.includes(i.prop))
      }

      this.tableHeaders = tableHeaders
      this.fullscreen = this.exec[115] === 1
      this.handeleIndex(item)
      this.item = item
      this.processIn = processIn
      this.show = true
    },
    handeleIndex(item) {
      let num1 = 1
      let num2 = 1
      let num3 = 1
      item.instrument.forEach((v) => {
        if (v.type === 0) {
          v.index = num1
          num1= num1 +1
        } else if (v.type === 1) {
          v.index = num2
          num2 = num2 +1
        } else if (v.type === 2) {
          v.index = num3
          num3 = num3 +1
        }
      })
    },
    toggleFullScreen() {
      // 切换全屏
      this.fullscreen = !this.fullscreen
      this.$nextTick(() => {
        this.$refs.instruments.doLayout()
      })
    },
    close() {
      this.show = false
    },
    openFile(item) {
      // 打开视频弹框
      const { extension, url } = item
      const ext = extension.toLowerCase()
      if (videoTypes.includes(ext)) {
        this.video.url = url
        this.video.show = true
      } else {
        window.open(url, '_blank')
      }
    },
    recordQuestion() {
      // 器械问题登记
      const { recycle_ids, id, name, number, code } = this.item
      const query = {
        table_id: recycle_ids,
        instrumentset_id: id,
        instrumentset_name: name,
        number: number? number : 1, 
        code: code? code : '',
      }
      this.$refs.cleanUnstanard.open(query, 'clean', 0, 6)
    },
    questionRecordDone() {
      // 重新获取详情
      this.$emit('refresh')
    },
    udiColor(item) {
      const {
        udi_scaned,
        udi_issue_status
      } = item
      
      if (udi_scaned) {
        return this.udiScanedColor
      } else if (udi_issue_status === 1) {
        return this.udiIssueColor
      }

      return ''
    },
    needCheckUdi() {
      // 需要校验udi（器械明细存在udi数据，并且udi的数据既没有扫码也没登记问题）
      const { instrument } = this.item
      const udiInstruments = instrument.filter(i => i.udi)
      
      return udiInstruments.filter(i => !i.udi_scaned && !i.udi_issue_status).length > 0
    },
    async beforeClose(done) {
      let confirm = true
      const { processIn } = this
      if (this.needCheckUdi()) {
        if (processIn === 'prepareToPack' && this.exec[320]) {
          // this.$message.error('请先扫描器械udi或标记问题')
          this.$message.error(`请先扫描器械udi或标记问题`)

          return
        }

        if ((processIn === 'recycle' || processIn === 'prepare' || processIn === 'prepareToPack')) {
          // confirm = await this.$utils.confirm({ msg: '您有未扫码的器械，是否继续？' })
          confirm = await this.$confirm(`您有未扫码的器械，是否继续？`)
        }
      }
      
      if (confirm) {
        this.$emit('close', true)
        done()
      }
    },
    checkRfids(ids) {
      // 检查rfid并标记、提示
      const udiData = ids.map(i => {
        return {
          udi: i,
          matched: false
        }
      })

      const { type, inner_code } = this.item
      if (type === 1 && inner_code) {
        // 检查器械udi列表并匹配、提示
        let n = 0
        this.item.instrument.forEach(i => {
          udiData.forEach(u => {
            if (i.udi === u.udi) {
              n += 1
              this.$set(i, 'udi_scaned', 1)
              u.matched = true
            }
          })
        })

        if (n) {
          // 成功识别 件器械
          this.$utils.speak(`成功识别`+` ${n} `+`件器械`)
        }

        const unMatched = udiData.filter(i => !i.matched)
        if (unMatched.length) {
          // 打开udi弹窗
          const { UdiList } = this.$refs

          UdiList && UdiList.open(unMatched.map(i => i.udi))
          // this.$utils.speak(`有${unMatched.length}件多余器械，请确认`)
          this.$utils.speak(`有 ${unMatched.length} 件多余器械，请确认`)
        }
      }
    },
    bindUdi(udi) {
      // 绑定udi
      if (!this.udiNodes.reduce((a, b) => a.nodes.concat(b.nodes)).includes(this.processIn)) return

      const { recycle_ids } = this.item
      const udiNodeMatched = this.udiNodes.filter(i => i.nodes.includes(this.processIn))[0]
      const udi_node = udiNodeMatched ? udiNodeMatched['type'] : 0
      const params = {
        recycle_id: recycle_ids[0],
        udi,
        udi_node
      }
      this.$request('post', saveUdi, params)
      .then(res => {
        if (res) {
          // this.$message.success('操作成功')
          this.$message.success(`操作成功`)
          this.$emit('refresh')
        }
      })
    },
    handleDelUdi(item) {
      // 删除udi
      const { udi } = item
      const { recycle_ids } = this.item
      const udiNodeMatched = this.udiNodes.filter(i => i.nodes.includes(this.processIn))[0]
      const udi_node = udiNodeMatched ? udiNodeMatched['type'] : 0
      const params = {
        recycle_id: recycle_ids[0],
        udi,
        udi_node
      }

      this.$request('post', deleteUdi, params)
      .then(res => {
        if (res) {
          // this.$message.success('操作成功')
          this.$message.success(`操作成功`)
          this.$emit('refresh')
        }
      })
    },
    tableRowClassName({row}) {
      let rowColor
      const color = this.tableColor.filter(i => i.value === row.type)[0]
      rowColor = color ? color.name : ''

      return { backgroundColor: rowColor }
    },
    indexMethod(index) {
      let num = 1
      this.item.instrument.forEach((val, ind) => {
        if (ind === index) {
          num = val.index
        }
      })
      return num
    }
  }
}
</script>

<style lang="scss" scoped>
  // .cover {
  //   width: 320px;
  //   margin: 0 10px 0 0;
  // }
  .container {
    max-height: 74vh;
    overflow-y: auto;
  }
  .info-line {
    >span{
      margin: 4px auto;
    }
    .el-tag {
      vertical-align: middle;
    }
    .highlight {
      font-weight: bold;
      font-size: 18px;
    }
  }
  .fullscreen-btn {
    position: absolute;
    top: 3px;
    right: 80px;
    border-color: #fff !important;
  }
  .tiny-img {
    width: 40px;
    height: 40px;
    margin: 4px;
  }
  .title {
    font-weight: bold;
    font-size: 16px;
  }
  .video-item {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .left {
    width: 320px;
    margin: 0 10px 10px 0;
    flex-shrink: 0;
    .image-list {
      height: 320px;
      width: 100%;
    }
    .cover {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    flex: 1;
    overflow: hidden;
  }
</style>